/// <reference path="Apps/Main/MainApp.ts"/>

module EEX.McEc {
 
    export function startMain(appContainer: HTMLElement) {
        // ReSharper disable once WrongExpressionStatement
        new Apps.MainApp(appContainer, { requiresLogin: true });
    }

}